import React from "react";

import { Box } from "@whoosh/design-system/src/components/primitive";

type BoxProps = React.ComponentProps<typeof Box>;

export type ContainerProps = BoxProps & {
  children?: React.ReactNode | React.JSX.Element | React.JSX.Element[];
};

export const Container = ({
  children,
  paddingHorizontal,
  px,
  testID,
  ...rest
}: ContainerProps) => {
  return (
    <Box
      maxWidth={1240}
      width="100%"
      style={{ marginHorizontal: "auto" }}
      position="relative"
      testID={testID}
      {...rest}
      paddingHorizontal={
        paddingHorizontal !== undefined
          ? paddingHorizontal
          : px !== undefined
          ? px
          : { base: 6, md: 17 }
      }
    >
      {children}
    </Box>
  );
};
